import { h, Fragment } from 'preact';
import useFormStore from '../../store/useFormStore';
import Checkbox from '../form/Checkbox';

export default function ServicesCheckBoxList({ services }) {
  const selected = useFormStore((state) => state.selectedServices) || [];
  const setSelected = useFormStore((state) => state.setSelectedServices);
  const clearServiceConfiguration = useFormStore((state) => state.clearServiceConfiguration);

  const toggleItem = (item) => {
    const currentSelected = selected || [];
    const isCurrentlySelected = currentSelected.includes(item);

    // If deselecting a service, clear its configuration from the cart
    if (isCurrentlySelected) {
      clearServiceConfiguration(item);
    }

    // Update selected services
    setSelected(
      isCurrentlySelected
        ? currentSelected.filter((i) => i !== item)
        : [...currentSelected, item]
    );
  };

  return (
    <div>
      <div className="text-xl font-semibold mb-3">What services do you need?<span className="text-coit-error ml-1">*</span></div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-5">
        {services.map((service) => {
          const isSelected = selected.includes(service.id);

          return (
            <Checkbox
              key={service.id}
              checked={isSelected}
              onChange={() => toggleItem(service.id)}
              label={service.name}
              className=""
              labelClassName="text-lg"
              inputClassName="h-6 w-6"
            />
          );
        })}
      </div>
    </div>
  );
}
